<template>
  <div class="message-box" v-if="visible">
    <div class="message-box__content">
      <div class="message-box__header" :style="setBgColor" :class="{showicon:showicon}">
        <span class="message-box__header__title">
          <slot name="title">
            <span class="title__text">
            {{title}}
            </span>
          </slot>
        </span>
      </div>
      <div class="vicp-close" @click="off">
        <i class="vicp-icon4" />
      </div>
      <div class="message-box__body">
        <slot name="body"></slot>
        <div class="message-box__error" v-if="error">
          <slot name="error">{{error}}</slot>
        </div>
      </div>
      <div class="message-box__footer">
        <slot name="footer"></slot>
      </div>
    </div>

  </div>
</template>

<script>
import lockScroll from '@/utils/lockScroll';

export default {
  mixins: [lockScroll],
  name: 'message-box',
  props: {
    showicon: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: '',
    },
    visible: {
      type: Boolean,
      default: true,
    },
    error: {
      type: String,
      default: '',
    },
    globalConfig:{
      type:Object,
      default:()=>{}
    }
  },
  methods: {
    off() {
      this.$emit('off');
      this.$emit('update:visible', false);
    },
  },
  computed:{
    setBgColor(){
      return{
        'backgroundColor':this.globalConfig.vice
      }
    }
  },
  mounted(){
    
  }
};

</script>
<style lang='less' scoped>
  .message-box {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    background:rgba(12, 12, 12, 0.616);

    // border:1px solid rgba(190,190,190,1);
    // border-radius:6px;
    z-index: 10;
    &__content {
      position: relative;
      width:409px;
      display: flex;
      background: rgba(255,255,255,1);;
      flex-direction: column;
      border-radius:20px;
    }
    &__header {
      padding-top: 16px;
      padding-bottom: 14px;
      box-sizing: border-box;
      width:100%;
      height:63px;
      // background-image:url('~@/assets/images/login-header.png');
      background-size: cover;
      border-radius:20px 20px 0 0;
      position: relative;
      text-align: center;
      &.showicon {
        // padding-top:51px;
        // padding-bottom: 10px;
        // height: 94px;
        // &::after {
        //   z-index: 1;
        //   content:"";
        //   // background-image: url('~@/assets/images/login-icon.png');
        //   background-size: 104px 91px;
        //   background-color: white;
        //   background-position: center center;
        //   border-radius: 53px;
        //   height: 90px;
        //   width: 90px;
        //   display: block;
        //   position: absolute;
        //   top: -55px;
        //   left: 0;
        //   right: 0;
        //   margin: auto;
        //   border: 8px solid #68953C;
        //   box-sizing: content-box;
        // }
      }
      &__cat {
        position: absolute;
        top: -142px;
        left: 0;
        z-index: 1;
        width: 267px;
        height: 230px;
      }
      &__title {
        text-align: center;
        position: relative;
        display: inline-block;
        z-index: 2;
        .title__text {
          width: 100px;
          height: 33px;
          font-size: 24px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: rgba(255, 255, 255, 1);
          line-height: 33px;
        }
      }
    }
    &__body {
      width:100%;
      height: auto;
      background:none;
      z-index: 2;
      margin-bottom: 20px;
    }
    &__error {
      position: relative;
      margin-top: 16px;
      width: 100%;
      text-align: center;
      height:17px;
      font-size:12px;
      font-family:PingFangSC-Regular,PingFang SC;
      font-weight:400;
      color:rgba(233,43,51,1);
      line-height:17px;
      text-shadow:0px 0px 8px rgba(0,0,0,0.3);
      &::before {
        content:"!";
        display: inline-block;
        // position: absolute;
        font-size: 20px;
        line-height: 27.88px;
        width: 27.88px;
        height: 27.88px;
        border-radius:50%;
        color: #fff;
        background-color: #E92B33;
        font-size: 9px;
        transform: scale(0.5);
        left: 0;
      }
    }
    &__footer {
      margin-bottom: 28px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-evenly;
      width: 100%;
      z-index: 2;
      p {
        margin-block-start: 8px;
        margin-block-end: 0em;
        margin-inline-start: 0px;
        margin-inline-end: 0px;
      }
    }
  }
 .vicp-close .vicp-icon4 {
  position: relative;
  display: block;
  width: 30px;
  height: 30px;
  cursor: pointer;
  -webkit-transition: -webkit-transform 0.18s;
  transition: -webkit-transform 0.18s;
  transition: transform 0.18s;
  transition: transform 0.18s, -webkit-transform 0.18s;
  -webkit-transform: rotate(0);
  -ms-transform: rotate(0);
  transform: rotate(0);
}
.vicp-close .vicp-icon4::after,
.vicp-close .vicp-icon4::before {
  -webkit-box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.23);
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.23);
  content: "";
  position: absolute;
  top: 12px;
  left: 4px;
  width: 20px;
  height: 2px;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
  background-color: #fff;
}
.vicp-close .vicp-icon4::after {
  -webkit-transform: rotate(-45deg);
  -ms-transform: rotate(-45deg);
  transform: rotate(-45deg);
}
.vicp-close .vicp-icon4:hover {
  -webkit-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  transform: rotate(90deg);
}
.vicp-close {
  position: absolute;
  right: 4px;
  top: 4px;
}
</style>
